// A planet as an icon (docs/02-Game-Design/Alignments.md): in the score
// panel, the alignment picker, the planet's tooltip and the score detail.
// Lit while its alignment is in force, dimmed while the planet is free
// again, a dotted outline before it has ever been surrounded.
import { PLANET_UNITS, planetAppearance, planetPath, type Planet, type PlayLevel } from '@wits/core';
import type { CSSProperties } from 'react';

export type PlanetIconState = 'active' | 'inactive' | 'unrevealed';

interface Props {
  level: PlayLevel;
  planet: Planet;
  size?: number;
  state?: PlanetIconState;
  className?: string;
}

export function PlanetIcon({ level, planet, size = 24, state = 'active', className }: Props) {
  const look = planetAppearance(level, planet);
  const k = (size * 0.9) / PLANET_UNITS;
  const c = size / 2;
  const style = { '--planet': `var(--planet-${look.kind})` } as CSSProperties;
  return (
    <svg className={['planet-icon', `is-${state}`, className ?? ''].join(' ').trim()} width={size} height={size} viewBox={`0 0 ${size} ${size}`} style={style} aria-hidden="true">
      {state === 'unrevealed' ? (
        <circle className="planet-icon-outline" cx={c} cy={c} r={size * 0.36} />
      ) : (
        <g transform={`translate(${c} ${c}) scale(${k.toFixed(4)})`}>
          <path className="planet-icon-body" d={planetPath(look)} />
        </g>
      )}
    </svg>
  );
}
